import BigLogo from "@publicPortal/components/bigLogo/BigLogo";
import Board from "@publicPortal/components/board/Board";
import ResultBoard from "@publicPortal/components/resultBoard/ResultBoard";
import { PublicPortalRoutingService } from "@publicPortal/services/PublicPortalRoutingService";
import { UserService } from "@publicPortal/services/UserService";
import { useState } from "react";
import ForgotPasswordBoilerplate from "@mirage/components/forgotPassword/ForgotPasswordBoilerplate";

const ForgotPassword = () => {
    const userService = new UserService();
    const [emailAddress, setEmailAddress] = useState("");
    const pp = new PublicPortalRoutingService();
    const [resultBoard, setResultBoard] = useState({
        show: false,
        isLoading: false,
        success: false,
        message: "",
    });

    const getResultBoard = () => {
        return (
            <ResultBoard
                loading={resultBoard.isLoading}
                success={resultBoard.success}
                message={resultBoard.message}
                headerText={"Reset password"}
                buttonLabel={"Back to Login"}
                buttonNavTo={pp.LoginRoute()}
            >
                {resultBoard.success ? (
                    <>
                        <b>{emailAddress}</b>
                        <p>Please check your inbox to continue.</p>
                    </>
                ) : undefined}
            </ResultBoard>
        );
    };

    return (
        <>
            <BigLogo />
            {resultBoard.show ? (
                getResultBoard()
            ) : (
                <Board headerText="Provide your email" size="small">
                    <ForgotPasswordBoilerplate
                        service={userService}
                        emailAddress={emailAddress}
                        setEmailAddress={setEmailAddress}
                        setResultBoard={setResultBoard}
                        backButtonRoute={pp.LoginRoute()}
                    />
                </Board>
            )}
        </>
    );
};

export default ForgotPassword;
